import { z } from 'zod'

import { dbEntitySchema } from './system'

export const ServerSchema = dbEntitySchema.extend({
  organization: z.string(),
  venues: z.array(z.string()).optional(),
  profileImage: z.string().nullable(),
  firstName: z.string(),
  lastName: z.string(),
  phone: z.string().optional(),
  email: z.string().optional(),
  title: z.string().optional(),
})

export const serverCreateArgsSchema = z.object({
  organizationId: z.string(),
  venueIds: z.array(z.string()).optional(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().optional(),
  phone: z.string().optional(),
  profileImage: z.string().optional(),
})

export const serverUpdateByIdArgsSchema = z.object({
  venueIds: z.array(z.string()).optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().optional(),
  phone: z.string().optional(),
  profileImage: z.string().optional(),
})

export const serverListQuerySchema = z.object({
  organizationId: z.string().optional(),
  venueId: z.string().optional(),
  search: z.string().optional(),
  deleted: z.boolean().optional(),
})
